type UrlString = string | number | undefined;

export const joinUrl = (...urls: UrlString[]): string => {
  const protocol = urls[0]?.toString().match(/http(s)?:\/\//)?.[0];

  const fullUrlString = urls
    .filter((el: unknown) => typeof el === "string" || typeof el === "number")
    .filter(Boolean)
    .join("/")
    .replace(protocol ?? "", "")
    .replaceAll(/\/+/g, "/");

  return (protocol ?? "") + fullUrlString.replace(protocol ?? "", "");
};
